import { combineReducers } from "redux";
import  dataModule  from "./dataModule";
import  monitorModule  from "./monitorModule";

export default combineReducers({ dataModule, monitorModule });